import { render, staticRenderFns } from "./user-header.vue?vue&type=template&id=4240e14a&scoped=true"
import script from "./user-header.vue?vue&type=script&lang=js"
export * from "./user-header.vue?vue&type=script&lang=js"
import style0 from "./user-header.vue?vue&type=style&index=0&id=4240e14a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4240e14a",
  null
  
)

export default component.exports